import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { environment } from '@environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccessTokenInterceptor implements HttpInterceptor {

  constructor(
    private authenticationService: AuthenticationService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isLogoutRequest = request.url.endsWith('auth/logout');
    const isRefreshTokenRequest = request.url.endsWith('auth/refresh-token');
    const isLoginWithAdRequest = request.url.endsWith('auth/sign-in-with-ad');
    const isLoginWithGoogleRequest = request.url.endsWith('auth/sign-in-with-google');

    if (isLogoutRequest || isRefreshTokenRequest || isLoginWithAdRequest || isLoginWithGoogleRequest) {
      return next.handle(request);
    }

    const idToken = this.authenticationService.idToken;
    const accessToken = this.authenticationService.accessToken;

    const isRequestToUploadUrl = request.url.startsWith(environment.UPLOAD_URL);
    if (isRequestToUploadUrl && idToken) {
      request = request.clone({
        setHeaders: {
          'authorization': `Bearer ${idToken}`,
          'x-access-token': `Bearer ${idToken}`,
        }
      });
    }

    const isRequestToGraphql = request.url.endsWith('/graphql');
    if (isRequestToGraphql && accessToken) {
      request = request.clone({
        setHeaders: {
          'authorization': request.headers.get('authorization') || `Bearer ${accessToken}`,
          'x-access-token': request.headers.get('x-access-token') || `Bearer ${accessToken}`,
          'x-client-application-name': 'mountdoom',
          'authorizationApp': 'mountdoom'
        }
      });
    }

    const isThemirrorRequest = request.url.startsWith(environment.THE_MIRROR_URL);
    if (isThemirrorRequest && idToken) {
      request = request.clone({
        setHeaders: {
          'authorization': `Bearer ${idToken}`,
          'x-access-token': `Bearer ${idToken}`,
          'X-App-Name': 'mountdoom',
          'X-Env-Name': environment.environment
        }
      });
    }

    return next.handle(request);
  }
}

